import axios from 'axios';

import routes from 'app/routes';

export default {
  prepareSteps: (callback) => {
    axios
      .get(routes.api.required_actions.list, {
        params: { type: 'session_feedback' },
      })
      .then((resp) => {
        const steps = [
          { type: 'welcome', position: 1 },
          ...resp.data.data.map((item, index) => ({
            type: 'feedback',
            position: index + 2,
            id: item.id,
            ...item.attributes,
          })),
          { type: 'thank_you', position: 4 },
        ];
        callback(steps);
      });
  },
  skip: (type, ids, callback) => {
    axios
      .post(routes.api.required_actions.skip, {
        type,
        ids,
      })
      .then((_resp) => {
        callback();
      });
  },
};
